import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ListItemIcon, ListItemText } from "@mui/material";

interface Props {
  Btn: JSX.Element;
  items: {
    icon?: JSX.Element;
    text: string;
    onClick: () => void;
  }[];
}

export default function BasicMenu({ items, Btn }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {Btn}
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock
        sx={{
          left: "56px",
        }}
      >
        {items.map((item, index) => {
          return (
            <MenuItem
              key={index}
              onClick={() => {
                handleClose();
                item.onClick();
              }}
              style={{ gap: "10px" }}
            >
              <ListItemText style={{ textAlign: "right" }}>{item.text}</ListItemText>
              {item.icon && <ListItemIcon style={{ justifyContent: "end" }}>{item.icon}</ListItemIcon>}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
